import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
const DepartmentDialog = props => {
  const [departmentFieldsProps, setDepartmentFieldsProps] = useState({
    name: { error: false, helperText: '' }
  });

  const handleBlur = e => {
    const name = e?.target?.name;
    const value = e?.target?.value;
    if (value?.trim() === '') {
      setDepartmentFieldsProps({
        ...departmentFieldsProps,
        [name]: { error: true, helperText: 'Field must not be empty' }
      });
    } else {
      setDepartmentFieldsProps({
        name: { error: false, helperText: '' }
      });
    }
  };
  return (
    <div id="DepartmentDialog">
      <div className="DepartmentDialogTitle">
        {props.department.id ? props.department.name : 'New Department'}
      </div>

      <div className="DepartmentDialogContent">
        <TextField
          onChange={e => {
            props.handleChange(e);
          }}
          defaultValue={props.department.name}
          name="name"
          required
          autoFocus
          margin="dense"
          id="Name"
          label="Name"
          type="text"
          fullWidth
          onBlur={handleBlur}
          {...departmentFieldsProps?.name}
        />
      </div>

      <div className="DepartmentDialogActions">
        <Button onClick={props.cancel}>Cancel</Button>
        <Button onClick={props.saveDepartment} disabled={!props.isValid} color="primary">
          {props.department.id ? 'Save' : 'Create'}
        </Button>
      </div>
    </div>
  );
};
export default DepartmentDialog;
